export const CATEGORIA_CUENTA_CONTABLE_ENUM = {
  OTRO: 0,
  CLIENTE: 1,
  PROVEEDOR: 2,
  COMPRA: 3,
  VENTA: 4,
  PRESTAMO_CONCEDIDO: 5,
  PRESTAMO_RECIBIDO: 6,
  INTERES_PRESTAMO_CONCEDIDO: 7,
  INTERES_PRESTAMO_RECIBIDO: 8,
  IVA_COMPRA: 9,
  IVA_VENTA: 10,
  RETENCION_COMPRA: 11,
  RETENCION_VENTA: 12,
  CUENTA_BANCARIA: 13,
  COMISION_APERTURA_PRESTAMO_CONCEDIDO: 14,
  COMISION_APERTURA_PRESTAMO_RECIBIDO: 15,
  COMISION_CORRETAJE_PRESTAMO_CONCEDIDO: 16,
  COMISION_CORRETAJE_PRESTAMO_RECIBIDO: 17,
  COMISION_DISPOSICION_PRESTAMO_CONCEDIDO: 18,
  COMISION_DISPOSICION_PRESTAMO_RECIBIDO: 19,
  COMISION_ESTUDIO_PRESTAMO_CONCEDIDO: 20,
  COMISION_ESTUDIO_PRESTAMO_RECIBIDO: 21,
  COMISION_OTRA_PRESTAMO_RECIBIDO: 22,
  COMISION_OTRA_PRESTAMO_CONCEDIDO: 23,
  ACTIVO: 24,
  ACTIVO_CONTRAPARTIDA: 25,
  ACTIVO_AMORTIZACION_ACUMULADA: 26,
  ACTIVO_AMORTIZACION_GASTOS: 27,
  TICKET_REEMBOLSO: 28,
} as const

export type CategoriaCuentaContableEnumType =
  (typeof CATEGORIA_CUENTA_CONTABLE_ENUM)[keyof typeof CATEGORIA_CUENTA_CONTABLE_ENUM]
